import { SubmitButton, SubmitButtonConfig } from 'ui/components/SubmitButton'
import { fleetApi } from 'api'
import { SUCCESS_VEHICLES_UPDATE } from 'texts/vehicleDetails'
import { URLS } from 'constants/urls'
import { pendingCarsCountSelector } from 'redux/fleet/selectors'
import { VEHICLE_DETAILS_FORM_ID } from '../../constants'

const vehiclesConfig: SubmitButtonConfig = {
  formId: VEHICLE_DETAILS_FORM_ID,
  pendingCountSelector: pendingCarsCountSelector,
  completeApiRequest: (companyId) =>
    fleetApi.vehicleComplete(Number(companyId)),
  successMessage: SUCCESS_VEHICLES_UPDATE,
  pageStatusKey: 'carsStatus',
  navigateUrl: `${URLS.FLEET}${URLS.VEHICLES}`,
  textKey: 'VEHICLES',
}

export const VehicleSubmitButton = () => (
  <SubmitButton config={vehiclesConfig} />
)
